<template>
    <button type="button" class="p-bench-toggle" :class="{ 'p-bench-toggle--open': open }" @click="$emit('toggle')">
        <span class="p-bench-toggle__strip" :style="{ backgroundColor: team.color }" />
        <span class="p-bench-toggle__text">
            <span class="p-bench-toggle__label">Bench</span>
            <span class="p-bench-toggle__count">{{ team.bench.length }}</span>
        </span>
        <span class="p-bench-toggle__faces">
            <span v-for="item in team.bench.slice(0, faces)" :key="`face-${item.player.id}`" class="p-bench-toggle__face">
                <span class="p-bench-toggle__face-jersey">{{ item.jersey }}</span>
            </span>
        </span>
        <v-icon small class="p-bench-toggle__chevron">{{ open ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
    </button>
</template>

<script>
    // Collapsed bench of one team: count + the first few faces; emits toggle
    export default {
        name: 'StatsBenchToggle',
        props: {
            team: {
                type: Object,
                required: true
            },
            open: {
                type: Boolean,
                default: false
            },
            faces: {
                type: Number,
                default: 3
            }
        }
    }
</script>
